
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clergy",
      function () {
        return require("private-next-pages/clergy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clergy"])
      });
    }
  